var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDispatch, useSelector } from 'react-redux';
import { CreateAppSheetSubTitle, CreateAppSheetTitle, CreateAppChangeLogo, AppNameInputField, InputLabelText, ResponsiveContainer, CreateAppLogoImage, CreateAppNameAndLogoPreviewContent, CreateAppName, Container, CreateAppContainer, MaxWidthContainer, DevicePreviewColumn, AppNameInvalidMessage, AppNameLimit, AppNameMessageContainer, UnstyledSpacer, } from '../styles';
import DevicePreview from '../components/DevicePreview';
import defaultAppIcon from '../../../images/default-app-icon.png';
import AppIconUploader from '../components/AppIconUploader';
import { selectAppCreationFlow } from '@project/store/createAppFlow/selectors';
import { changeAppNameAndLogo } from '@project/store/createAppFlow/actions';
import { AppEditTypes } from '@project/store/createAppFlow/models';
var CreateAppLogoAndName = function () {
    var dispatch = useDispatch();
    var _a = useSelector(selectAppCreationFlow), name = _a.name, logo = _a.logo, isNameEmpty = _a.isNameEmpty, creationType = _a.creationType, _b = _a.selectedTemplate.icon, icon = _b === void 0 ? '' : _b;
    var handleNameLogoChange = function (value, type) {
        if (type === 'NAME' && (value === null || value === void 0 ? void 0 : value.length) > 35) {
            dispatch(changeAppNameAndLogo(value === null || value === void 0 ? void 0 : value.substring(0, 35), type));
        }
        else {
            dispatch(changeAppNameAndLogo(value, type));
        }
    };
    var getCurrentImage = function () {
        if (logo && creationType === 'SCRATCH') {
            return logo;
        }
        else if (creationType === 'TEMPLATE') {
            if (logo) {
                return logo;
            }
            else if (icon) {
                return icon;
            }
            else {
                return defaultAppIcon;
            }
        }
        else {
            return defaultAppIcon;
        }
    };
    return (_jsx(ResponsiveContainer, __assign({ noHeight: true, marginTop: 40 }, { children: _jsx(MaxWidthContainer, { children: _jsxs(CreateAppContainer, { children: [_jsxs(Container, { children: [_jsx(CreateAppSheetSubTitle, { children: "Create app identity" }), _jsx(CreateAppSheetTitle, { children: "Set a name and logo for your app" }), _jsx(AppIconUploader, { icon: getCurrentImage(), onChange: function (value) {
                                    return handleNameLogoChange(value, AppEditTypes.LOGO);
                                } }), _jsx(CreateAppChangeLogo, { children: "Click on the logo to change" }), _jsxs(Container, { children: [_jsx(InputLabelText, { children: "App name" }), _jsx(AppNameInputField, { error: !isNameEmpty, value: name, placeholder: "Enter your app name", onChange: function (e) {
                                            return handleNameLogoChange(e.target.value, AppEditTypes.NAME);
                                        } }), _jsxs(AppNameMessageContainer, { children: [isNameEmpty ? (_jsx(AppNameInvalidMessage, { children: "Missing information. Please fill out this field to proceed." })) : (_jsx(UnstyledSpacer, {})), _jsxs(AppNameLimit, { children: [name === null || name === void 0 ? void 0 : name.length, "/35"] })] })] })] }), _jsx(DevicePreviewColumn, __assign({ position: "flex-end" }, { children: _jsx(DevicePreview, __assign({ disableTopBar: true }, { children: _jsxs(CreateAppNameAndLogoPreviewContent, { children: [_jsx(CreateAppLogoImage, { src: getCurrentImage(), alt: "app-icon" }), _jsx(CreateAppName, { children: name })] }) })) }))] }) }) })));
};
export default CreateAppLogoAndName;
